import React, { useEffect, useRef } from 'react';
import { View, SxProp } from 'dripsy';

import { UniSkeleton } from '@/design-system/components/cards';
import { TextAmount, TextCaption } from '@/design-system/components/typography/UniTypography';

export interface UniSubscribedAssetOverviewCardProps {
  overviewData?: {
    totalValueStaked: string;
    dailyEarnings: string;
    totalRewardsAccrued: string;
    currency: string;
  };
  loading?: boolean;
}

export const UniSubscribedAssetOverviewCard: React.FC<UniSubscribedAssetOverviewCardProps> = (props) => {
  const { loading, overviewData } = props;

  const componentMounted = useRef(true);

  useEffect(() => {
    return () => {
      componentMounted.current = false;
    };
  }, []);

  if (loading) {
    return <UniSubscribedAssetOverviewCardLoading />;
  }

  return (
    <View sx={sxStyles.container}>
      {/* Top */}
      <View sx={sxStyles.containerTop}>
        <TextCaption secondary label>
          Total Value Staked
        </TextCaption>
        <TextAmount size="H6" weight="bold" currency={overviewData?.currency || ''} shouldHide>
          {overviewData?.totalValueStaked || ' - '}
        </TextAmount>
      </View>
      {/* Bottom */}
      <View sx={sxStyles.containerBottom}>
        <View sx={sxStyles.containerBottomLeft}>
          <TextCaption secondary label>
            Daily Earnings
          </TextCaption>
          <TextAmount size="textBody" weight="semiBold" currency={overviewData?.currency || ' - '} success shouldHide>
            {overviewData?.dailyEarnings || ' - '}
          </TextAmount>
        </View>
        <View sx={sxStyles.containerBottomRight}>
          <TextCaption secondary label>
            Total Award Accrued
          </TextCaption>
          <TextAmount size="textBody" weight="semiBold" currency={overviewData?.currency || ' - '} shouldHide>
            {overviewData?.totalRewardsAccrued || ' - '}
          </TextAmount>
        </View>
      </View>
    </View>
  );
};

const UniSubscribedAssetOverviewCardLoading: React.FC = () => (
  <View sx={sxStyles.container}>
    {/* Top */}
    <View sx={sxStyles.containerTop}>
      <UniSkeleton style={{ marginBottom: 4, height: 15, width: 110 }} />
      <UniSkeleton style={{ height: 24, width: 250 }} />
    </View>
    {/* Bottom */}
    <View sx={sxStyles.containerBottom}>
      <View sx={sxStyles.containerBottomLeft}>
        <UniSkeleton style={{ marginBottom: 4, height: 15, width: 110 }} />
        <UniSkeleton style={{ height: 17, width: 150 }} />
      </View>
      <View sx={sxStyles.containerBottomRight}>
        <UniSkeleton style={{ marginBottom: 4, height: 15, width: 110 }} />
        <UniSkeleton style={{ height: 17, width: 150 }} />
      </View>
    </View>
  </View>
);

const sxStyles: Record<string, SxProp> = {
  container: {
    marginX: 16,
    paddingY: 20,
    borderBottomWidth: 1,
    borderBottomColor: '$borderPrimary'
  },
  containerTop: {},
  containerBottom: {
    mt: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  containerBottomLeft: {},
  containerBottomRight: {
    alignItems: 'flex-end'
  }
};

export default UniSubscribedAssetOverviewCard;
